const universalTitle = "BLÆST";
const baseUrl = "https://blstworld.com/";

import { StoryMetadata } from "@/components/bloks/guards";
import { defu } from "defu"; // https://unjs.io/packages/defu
import { type Metadata } from "next";
import { omitFalsy } from "./pick";

export const generateTitle = (pageTitle?: string) => {
  if (pageTitle)
    return pageTitle.toLowerCase().includes("blæst")
      ? pageTitle
      : `${pageTitle} | ${universalTitle}`;
  return universalTitle;
};

export const generateUrl = (path?: string) => {
  if (path) return `${baseUrl}${path.startsWith("/") ? path : "/" + path}`;
  return baseUrl;
};

export const metadataPlugin = (
  data: StoryMetadata["metadata"],
  additionalMetadata?: Partial<Metadata>,
): Metadata => {
  const metadata = omitFalsy(data);

  const title = metadata.title ?? additionalMetadata?.title ?? `BLÆST`;
  const description =
    metadata.description ?? additionalMetadata?.description ?? undefined;

  return defu(
    {
      metadataBase: new URL(baseUrl),
      title,
      description: metadata.description,
      openGraph: {
        title: metadata.og_title ?? title,
        description: metadata.og_description ?? description,
        siteName: "BLÆST",
        images: metadata.og_image ? [{ url: metadata.og_image }] : undefined,
      },
      twitter: {
        title: metadata.twitter_title ?? metadata.og_title ?? title,
        description: metadata.twitter_description ?? description,
        images: metadata.twitter_image
          ? [{ url: metadata.twitter_image }]
          : metadata.og_image
            ? [{ url: metadata.og_image }]
            : undefined,
      },
    },
    additionalMetadata,
  );
};

// TODO: handle metadata
// export const generateStoryMetadata = async (
//   story?: ISbStoryData<ProductPageStoryblok>,
//   additionalMetadata: Partial<Metadata> = {},
// ): Promise<Metadata> => {
//   if (!story) return additionalMetadata;

//   if (!hasMetadata(story)) {
//     // Todo - Notify content editor of missing metadata
//     return additionalMetadata;
//   }

//   const metadata = omitFalsy<Metadata>(story.content.metadata as Metadata);

//   const title = metadata.title ?? `${story.name} | BLÆST`;

//   return defu(
//     {
//       metadataBase: new URL(baseUrl),
//       title,
//       description: metadata.description,
//       keywords: story.tag_list.length > 0 ? story.tag_list : undefined,
//       openGraph: {
//         title: metadata.og_title ?? title,
//         description: metadata.og_description ?? metadata.description,
//         siteName: "BLÆST",
//         images: metadata.og_image ? [{ url: metadata.og_image }] : undefined,
//       },
//       twitter: {
//         title: metadata.twitter_title ?? title,
//         description: metadata.twitter_description,
//         images: metadata.twitter_image
//           ? [{ url: metadata.twitter_image }]
//           : metadata.og_image
//             ? [{ url: metadata.og_image }]
//             : undefined,
//       },
//     },
//     additionalMetadata,
//   );
// };
